import FlightIcon from "@mui/icons-material/Flight";

import CollapsibleListItem from "src/components/List/CollapsibleList";
import { useCourseRelationsContext } from "src/context/CourseRelationsContext";

import CoursesList from "./CoursesList";
import { highlightText } from "./utils";
import type { AircraftTreeItemProps } from "./types";

const AircraftTreeItem = ({ aircraft, nodeId, expandedNodeIds, searchTerm }: AircraftTreeItemProps) => {
  const key = `${nodeId}/a${aircraft.id}`;
  const actions = useCourseRelationsContext();

  const { courses, customCourses, groups, types } = aircraft;
  const hasItems = Boolean(courses?.length || customCourses?.length || groups?.length || types?.length);
  const isExpanded = expandedNodeIds?.has(key) ?? false;

  return (
    <CollapsibleListItem
      nodeId={key}
      icon={<FlightIcon />}
      isExpandable={hasItems}
      title={highlightText(aircraft.name, searchTerm)}
      onClick={() => actions.nodeClicked(key)}
      forceExpanded={isExpanded}
    >
      <CoursesList
        nodeId={key}
        courses={courses}
        customCourses={customCourses}
        groups={groups}
        searchTerm={searchTerm}
      />
      {types?.map((type) => (
        <AircraftTreeItem
          key={`${key}/a${type.id}`}
          aircraft={type}
          nodeId={key}
          expandedNodeIds={expandedNodeIds}
          searchTerm={searchTerm}
        />
      ))}
    </CollapsibleListItem>
  );
};

export default AircraftTreeItem;
